import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './tablerenderer.module.scss';

const cx = classnames.bind(styles);

class TableRenderer extends Component {
  static propTypes = {
    data: PropTypes.array,
  };

  static defaultProps = {
    data: [[]],
  };

  tableCell = ({ content, isHeader = false }) => {
    const className = cx('cell');
    let el = <td className={className}>{content}</td>;
    if (isHeader) el = <th className={className}>{content}</th>;
    return el;
  };

  render() {
    const { data } = this.props;
    return (
      <div className={cx('table-renderer-wrap')}>
        <table className={cx('table-renderer')}>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr>
                {row.map(cell => (
                  <this.tableCell
                    content={cell.value}
                    isHeader={rowIndex === 0}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TableRenderer;
